import { TeamListDto } from "../../../../core/models/teams/team-list-dto";

export const defaultColumns = [
  {
    columnDef: 'teamId',
    header: 'Maskinlagskod',
    cell: (element: TeamListDto) => element.teamId,
    route: (element: TeamListDto) => `/team/${element.id}`,
  },
  {
    columnDef: 'productionTechnicianAreaText',
    header: 'Prodteknikerområde',
    cell: (element: TeamListDto) => element.productionTechnicianAreaText,
  },
  {
    columnDef: 'created',
    header: 'Skapad',
    cell: (element: TeamListDto) => element.created,
    minWidth: 165
  },
  {
    columnDef: 'lastModified',
    header: 'Ändrad',
    cell: (element: TeamListDto) => element.lastModified,
    minWidth: 165
  }
]

export const baseColumns = [
  {
    columnDef: 'baseInfo.name',
    header: 'Namn',
    cell: (element: TeamListDto) => `${element.baseInfo.name}`,
  },
  {
    columnDef: 'baseInfo.productionLeaderText',
    header: 'Produktionsledare',
    cell: (element: TeamListDto) => `${`${element.baseInfo.productionLeaderText}`}`,
  },
  {
    columnDef: 'baseInfo.contractorText',
    header: 'Entreprenör',
    cell: (element: TeamListDto) => `${`${element.baseInfo.contractorText}`}`,
  },
  {
    columnDef: 'baseInfo.activeMachineIds',
    header: 'Maskiner',
    cell: (element: TeamListDto) => `${`${element.baseInfo.activeMachineIds?.join(', ')}`}`,
  }
];

export const productionInfoColumns = [
  {
    columnDef: 'productionInfo.typeText',
    header: 'Typ',
    cell: (element: TeamListDto) => `${element.productionInfo.typeText}`,
  },
  {
    columnDef: 'productionInfo.forwardingDelayInDays',
    header: 'Fördröjning (dagar)',
    cell: (element: TeamListDto) => `${element.productionInfo.forwardingDelayInDays}`,
    align: 'right'
  },
];

export const statusColumns = [
  {
    columnDef: 'productionInfo.statusInfo.statusText',
    header: 'Status',
    cell: (element: TeamListDto) => `${element.statusInfo.statusText}`,
  },
  {
    columnDef: 'productionInfo.statusInfo.ownerTypeText',
    header: 'Ägartyp',
    cell: (element: TeamListDto) => `${element.statusInfo.ownerTypeText}`,
  }
];

export const allColumns = [
  {
    columnDef: 'teamId',
    header: 'Maskinlagskod',
    cell: (element: TeamListDto) => element.teamId,
    route: (element: TeamListDto) => `/team/${element.id}`,
    visible: true,
    required: true
  },
  {
    columnDef: 'productionTechnicianAreaText',
    header: 'Prodteknikerområde',
    cell: (element: TeamListDto) => element.productionTechnicianAreaText,
    visible: true,
    required: false
  },
  {
    columnDef: 'created',
    header: "Skapat",
    cell: (element: TeamListDto) => `${element.created}`,
    visible: true,
    required: false,
    minWidth: 165
  },
  {
    columnDef: 'lastModified',
    header: "Ändrat",
    cell: (element: TeamListDto) => `${element.lastModified}`,
    visible: true,
    required: false,
    minWidth: 165
  },
  {
    columnDef: 'baseInfo.name',
    header: 'Namn',
    cell: (element: TeamListDto) => `${element.baseInfo.name}`,
    visible: true,
    required: false,
    minWidth: 165
  },
  {
    columnDef: 'baseInfo.productionLeaderText',
    header: 'Produktionsledare',
    cell: (element: TeamListDto) => `${`${element.baseInfo.productionLeaderText}`}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'baseInfo.contractorText',
    header: 'Ansvarig entreprenör',
    cell: (element: TeamListDto) => `${`${element.baseInfo.contractorText}`}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'baseInfo.activeMachineIds',
    header: 'Maskiner',
    cell: (element: TeamListDto) => `${`${element.baseInfo.activeMachineIds?.join(', ')}`}`,
  },
  {
    columnDef: 'productionInfo.typeText',
    header: 'Typ',
    cell: (element: TeamListDto) => `${element.productionInfo.typeText}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'productionInfo.forwardingDelayInDays',
    header: 'Fördröjning (dagar)',
    cell: (element: TeamListDto) => `${element.productionInfo.forwardingDelayInDays}`,
    visible: true,
    required: false,
    align: 'right'

  },
  {
    columnDef: 'statusInfo.statusText',
    header: 'Status',
    cell: (element: TeamListDto) => `${element.statusInfo.statusText}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'statusInfo.ownerTypeText',
    header: 'Ägartyp',
    cell: (element: TeamListDto) => `${element.statusInfo.ownerTypeText}`,
    visible: true,
    required: false
  }
]
